module.exports = __webpack_public_path__ + "media/npc_dota_hero_rubick.26e278b5.webm";